import { PRINTER_BRIDGE_URL } from "../../../config/printerBridge";

const requestId = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return `restaurant-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

async function readJson(response) {
  try { return await response.json(); } catch { return null; }
}

export async function checkRestaurantPrinter(signal) {
  const healthResponse = await fetch(`${PRINTER_BRIDGE_URL}/health`, { signal });
  const health = await readJson(healthResponse);
  if (!healthResponse.ok || health?.running !== true) return false;

  const statusResponse = await fetch(`${PRINTER_BRIDGE_URL}/printer/status`, { signal });
  const status = await readJson(statusResponse);
  const data = status?.data || status;
  return statusResponse.ok && data?.configured === true && data?.available === true;
}

export function mapRestaurantPrintJob(job) {
  const common = { requestId: requestId(), printJobId: job.jobId };

  if (job.documentType === "RECEIPT") {
    const financialFields = ["subtotal", "discount", "tax", "serviceCharge", "total"];
    if (financialFields.some((field) => job[field] == null || !Number.isFinite(Number(job[field])))) {
      return { invalid: "INCOMPLETE_RECEIPT_SNAPSHOT: Receipt financial snapshot is incomplete." };
    }
    return {
      payload: {
        ...common,
        documentType: "RECEIPT",
        invoiceNumber: job.documentNumber,
        dateTime: job.dateTime,
        orderNumber: job.orderNumber,
        items: (job.items || []).map(({ itemName, quantity, unitPrice, lineTotal }) => ({ itemName, quantity, unitPrice, lineTotal })),
        subtotal: job.subtotal,
        discount: job.discount,
        tax: job.tax,
        serviceCharge: job.serviceCharge,
        total: job.total,
      },
    };
  }

  if (job.documentType === "KOT") {
    return {
      payload: {
        ...common,
        documentType: "KOT",
        saleBillNumber: job.saleBillNumber,
        dateTime: job.dateTime,
        orderNumber: job.orderNumber,
        source: job.sourceOutletCode,
        items: (job.items || []).map(({ itemName, quantity }) => ({ itemName, quantity })),
      },
    };
  }
  return { invalid: `INVALID_REQUEST: Unsupported document type ${job.documentType || "(missing)"}.` };
}

export async function submitRestaurantDocument(payload, signal) {
  let response;
  let body;
  try {
    response = await fetch(`${PRINTER_BRIDGE_URL}/print`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal,
    });
    body = await readJson(response);
  } catch (error) {
    return { kind: "UNCERTAIN", diagnostic: error?.message || "Bridge response was not received." };
  }

  if (body?.success === true && body?.result === "SUBMITTED") return { kind: "SUBMITTED" };
  const errorData = body?.error || body?.data?.error || body?.data || body;
  const code = errorData?.code || errorData?.errorCode;
  const message = errorData?.message || errorData?.diagnostic || body?.message;
  if (body?.success === false && code && message) return { kind: "FAILED", code, message };
  return { kind: "UNCERTAIN", diagnostic: `Bridge response was ambiguous (HTTP ${response.status}).` };
}
